import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Section } from 'components';
import { ServiceTile } from '..';

const OtherServices = () => (
  <Section additionalClass={'fpdc__service-tile'} fullwidth spaceless>
    <Row className={'no-gap'}>
      <Col sm={12} md={6}>
        <ServiceTile
          title={'Development<br />Teams'}
          description={
            'Boldare’s skilled development teams can help you reach your business goals and guide you through the lean startup approach.'
          }
          textColor={'white'}
          backgroundColor={'mine-shaft'}
          link={'/development-teams/'}
          alignedLeft
        />
      </Col>
      <Col sm={12} md={6}>
        <ServiceTile
          title={'Digital<br />Transformation'}
          description={
            'Whether you’re looking to disrupt your department or entire industry Boldare teams will show you how you can make it happen.'
          }
          backgroundColor={'red'}
          link={'/digital-transformation/'}
        />
      </Col>
    </Row>
    <Row className={'no-gap'}>
      <Col sm={12} md={6}>
        <ServiceTile
          title={'Machine<br />Learning'}
          description={
            'Our experts will help you turn your big data into valuable source of information and insight, automate your decision-making processes and help you predict the future.'
          }
          backgroundColor={'gray-light'}
          link={'/machine-learning/'}
          alignedLeft
        />
      </Col>
      <Col sm={12} md={6}>
        <ServiceTile
          title={'Product Design<br />and Development'}
          description={
            'Boldare’s experienced specialists will look after every aspect of your product, from design and development, to DevOps, tech stack consulting and usability testing.'
          }
          backgroundColor={'pigeon-post'}
          link={'/product-design-and-development/'}
        />
      </Col>
    </Row>
  </Section>
);

export default OtherServices;
